export const countryList = [
  { name: 'Estonia', value: 'EE' },
  { name: 'Latvia', value: 'LV' },
  { name: 'Lithuania', value: 'LT' },
  { name: 'Finland', value: 'FI' },
  { name: 'Sweden', value: 'SE' },
  { name: 'Austria', value: 'AT' },
  { name: 'Belgium', value: 'BE' },
  { name: 'Bulgaria', value: 'BG' },
  { name: 'Spain', value: 'ES' },
  { name: 'Netherlands', value: 'NL' },
  { name: 'Croatia', value: 'HR' },
  { name: 'Ireland', value: 'IE' },
  { name: 'Iceland', value: 'IS' },
  { name: 'Italy', value: 'IT' },
  { name: 'Greece', value: 'GR' },
  { name: 'Cyprus', value: 'CY' },
  { name: 'Liechtenstein', value: 'LI' },
  { name: 'Luxembourg', value: 'LU' },
  { name: 'Malta', value: 'MT' },
  { name: 'Norway', value: 'NO' },
  { name: 'Poland', value: 'PL' },
  { name: 'Portugal', value: 'PT' },
  { name: 'France', value: 'FR' },
  { name: 'Romania', value: 'RO' },
  { name: 'Germany', value: 'DE' },
  { name: 'Slovakia', value: 'SK' },
  { name: 'Slovenia', value: 'SI' },
  { name: 'United Kingdom', value: 'GB' },
  { name: 'Switzerland', value: 'CH' },
  { name: 'Denmark', value: 'DK' },
  { name: 'Czechia', value: 'CZ' },
  { name: 'Hungary', value: 'HU' },
  { name: 'Afghanistan', value: 'AF' },
  { name: 'Albania', value: 'AL' },
  { name: 'Algeria', value: 'DZ' },
  { name: 'United States', value: 'US' },
  { name: 'Andorra', value: 'AD' },
  { name: 'Angola', value: 'AO' },
  { name: 'Antigua and Barbuda', value: 'AG' },
  { name: 'United Arab Emirates', value: 'AE' },
  { name: 'Argentina', value: 'AR' },
  { name: 'Armenia', value: 'AM' },
  { name: 'Azerbaijan', value: 'AZ' },
  { name: 'Australia', value: 'AU' },
  { name: 'Bahamas', value: 'BS' },
  { name: 'Bahrain', value: 'BH' },
  { name: 'Bangladesh', value: 'BD' },
  { name: 'Barbados', value: 'BB' },
  { name: 'Palau', value: 'PW' },
  { name: 'Belize', value: 'BZ' },
  { name: 'Benin', value: 'BJ' },
  { name: 'Bhutan', value: 'BT' },
  { name: 'Bolivia', value: 'BO' },
  { name: 'Bosnia and Herzegovina', value: 'BA' },
  { name: 'Botswana', value: 'BW' },
  { name: 'Brazil', value: 'BR' },
  { name: 'Brunei Darussalam', value: 'BN' },
  { name: 'Burkina Faso', value: 'BF' },
  { name: 'Burundi', value: 'BI' },
  { name: 'Colombia', value: 'CO' },
  { name: 'Costa Rica', value: 'CR' },
  { name: 'Djibouti', value: 'DJ' },
  { name: 'Dominica', value: 'DM' },
  { name: 'Dominican Republic', value: 'DO' },
  { name: 'Ecuador', value: 'EC' },
  { name: 'Egypt', value: 'EG' },
  { name: 'Equatorial Guinea', value: 'GQ' },
  { name: 'El Salvador', value: 'SV' },
  { name: 'Côte d\'Ivoire', value: 'CI' },
  { name: 'Eritrea', value: 'ER' },
  { name: 'Ethiopia', value: 'ET' },
  { name: 'Fiji', value: 'FJ' },
  { name: 'Philippines', value: 'PH' },
  { name: 'Gabon', value: 'GA' },
  { name: 'Gambia', value: 'GM' },
  { name: 'Ghana', value: 'GH' },
  { name: 'Grenada', value: 'GD' },
  { name: 'Georgia', value: 'GE' },
  { name: 'Guatemala', value: 'GT' },
  { name: 'Guinea', value: 'GN' },
  { name: 'Guinea-Bissau', value: 'GW' },
  { name: 'Guyana', value: 'GY' },
  { name: 'Haiti', value: 'HT' },
  { name: 'China', value: 'CN' },
  { name: 'Honduras', value: 'HN' },
  { name: 'Timor-Leste', value: 'TL' },
  { name: 'Israel', value: 'IL' },
  { name: 'India', value: 'IN' },
  { name: 'Indonesia', value: 'ID' },
  { name: 'Iraq', value: 'IQ' },
  { name: 'Iran', value: 'IR' },
  { name: 'Japan', value: 'JP' },
  { name: 'Jamaica', value: 'JM' },
  { name: 'Yemen', value: 'YE' },
  { name: 'Jordan', value: 'JO' },
  { name: 'Cambodia', value: 'KH' },
  { name: 'Cameroon', value: 'CM' },
  { name: 'Canada', value: 'CA' },
  { name: 'Kazakhstan', value: 'KZ' },
  { name: 'Qatar', value: 'QA' },
  { name: 'Kenya', value: 'KE' },
  { name: 'Central African Republic', value: 'CF' },
  { name: 'Kiribati', value: 'KI' },
  { name: 'Comoros', value: 'KM' },
  { name: 'Congo, Democratic Republic of the', value: 'CD' },
  { name: 'Congo, Republic of the', value: 'CG' },
  { name: 'Cuba', value: 'CU' },
  { name: 'Kuwait', value: 'KW' },
  { name: 'Kyrgyzstan', value: 'KG' },
  { name: 'Lao People\'s Democratic Republic', value: 'LA' },
  { name: 'Lesotho', value: 'LS' },
  { name: 'Liberia', value: 'LR' },
  { name: 'Lebanon', value: 'LB' },
  { name: 'Libya', value: 'LY' },
  { name: 'South Africa', value: 'ZA' },
  { name: 'South Korea', value: 'KR' },
  { name: 'South Sudan', value: 'SS' },
  { name: 'Madagascar', value: 'MG' },
  { name: 'Malaysia', value: 'MY' },
  { name: 'Malawi', value: 'MW' },
  { name: 'Maldives', value: 'MV' },
  { name: 'Mali', value: 'ML' },
  { name: 'Morocco', value: 'MA' },
  { name: 'Marshall Islands', value: 'MH' },
  { name: 'Mauritania', value: 'MR' },
  { name: 'Mauritius', value: 'MU' },
  { name: 'Mexico', value: 'MX' },
  { name: 'Micronesia (Federated States of)', value: 'FM' },
  { name: 'Moldova, Republic of', value: 'MD' },
  { name: 'Monaco', value: 'MC' },
  { name: 'Mongolia', value: 'MN' },
  { name: 'Montenegro', value: 'ME' },
  { name: 'Mozambique', value: 'MZ' },
  { name: 'Myanmar', value: 'MM' },
  { name: 'Namibia', value: 'NA' },
  { name: 'Nauru', value: 'NR' },
  { name: 'Nepal', value: 'NP' },
  { name: 'Nicaragua', value: 'NI' },
  { name: 'Nigeria', value: 'NG' },
  { name: 'Niger', value: 'NE' },
  { name: 'Oman', value: 'OM' },
  { name: 'Papua New Guinea', value: 'PG' },
  { name: 'Pakistan', value: 'PK' },
  { name: 'Panama', value: 'PA' },
  { name: 'Paraguay', value: 'PY' },
  { name: 'Peru', value: 'PE' },
  { name: 'North Korea', value: 'KP' },
  { name: 'North Macedonia', value: 'MK' },
  { name: 'Cabo Verde', value: 'CV' },
  { name: 'Rwanda', value: 'RW' },
  { name: 'Solomon Islands', value: 'SB' },
  { name: 'Saint Kitts and Nevis', value: 'KN' },
  { name: 'Saint Lucia', value: 'LC' },
  { name: 'Saint Vincent and the Grenadines', value: 'VC' },
  { name: 'Zambia', value: 'ZM' },
  { name: 'Samoa', value: 'WS' },
  { name: 'San Marino', value: 'SM' },
  { name: 'Sao Tome and Principe', value: 'ST' },
  { name: 'Saudi Arabia', value: 'SA' },
  { name: 'Seychelles', value: 'SC' },
  { name: 'Senegal', value: 'SN' },
  { name: 'Serbia', value: 'RS' },
  { name: 'Sierra Leone', value: 'SL' },
  { name: 'Singapore', value: 'SG' },
  { name: 'Somalia', value: 'SO' },
  { name: 'Sri Lanka', value: 'LK' },
  { name: 'Sudan', value: 'SD' },
  { name: 'Suriname', value: 'SR' },
  { name: 'Eswatini (Swaziland)', value: 'SZ' },
  { name: 'Syria', value: 'SY' },
  { name: 'Zimbabwe', value: 'ZW' },
  { name: 'Tajikistan', value: 'TJ' },
  { name: 'Thailand', value: 'TH' },
  { name: 'Tanzania', value: 'TZ' },
  { name: 'Togo', value: 'TG' },
  { name: 'Tonga', value: 'TO' },
  { name: 'Trinidad and Tobago', value: 'TT' },
  { name: 'Chad', value: 'TD' },
  { name: 'Chile', value: 'CL' },
  { name: 'Tunisia', value: 'TN' },
  { name: 'Tuvalu', value: 'TV' },
  { name: 'Türkiye', value: 'TR' },
  { name: 'Turkmenistan', value: 'TM' },
  { name: 'Uganda', value: 'UG' },
  { name: 'Ukraine', value: 'UA' },
  { name: 'Uruguay', value: 'UY' },
  { name: 'Uzbekistan', value: 'UZ' },
  { name: 'New Zealand', value: 'NZ' },
  { name: 'Belarus', value: 'BY' },
  { name: 'Vanuatu', value: 'VU' },
  { name: 'Vatican', value: 'VA' },
  { name: 'Russia', value: 'RU' },
  { name: 'Venezuela', value: 'VE' },
  { name: 'Vietnam', value: 'VN' },
];

export const getCountryByValue = (value: string) => {
  const country = countryList.find(item => item.value === value);
  return country ? country.name : '';
}